import redirects from "~/assets/data/redirects.json";

export default defineNuxtRouteMiddleware((to, from) => {
  const redirect_to = redirects[decodeURI(to.fullPath)];
  if (redirect_to) {
    return navigateTo(redirect_to, { redirectCode: 301 });
  }
})
